<script setup lang="ts">
import { useTimeAgo } from "@vueuse/core"
import { computed } from "vue"

const props = defineProps<{
  quantity: number
  consumable: boolean
  inventoriedAt: string | null
  archivedAt?: string | null
}>()

const inventoriedAgo = useTimeAgo(() => props.inventoriedAt ?? new Date())

const visible = computed(
  () => props.quantity > 1 || props.consumable || !!props.inventoriedAt || !!props.archivedAt,
)
</script>

<template>
  <div v-if="visible" class="flex items-center gap-4">
    <UBadge v-if="archivedAt" color="warning" variant="subtle" size="sm">Archived</UBadge>
    <UBadge v-if="quantity > 1" color="neutral" variant="subtle" size="sm">
      &times;{{ quantity }}
    </UBadge>
    <UBadge v-if="consumable" color="neutral" variant="subtle" size="sm">Consumable</UBadge>
    <UBadge v-if="inventoriedAt" color="success" variant="subtle" size="sm">
      Inventoried {{ inventoriedAgo }}
    </UBadge>
  </div>
</template>
